<template>
  <div class="auth-shell" :style="gridStyle">
    <!-- 左侧品牌宣传区域 -->
    <div class="promo-section">
      <AuthPromoPanel :asset="promoAsset" />
    </div>

    <!-- 右侧认证区域 -->
    <div class="auth-section">
      <div class="auth-content">
        <!-- 关闭按钮 -->
        <div class="close-button">
          <el-button
            type="text"
            @click="handleClose"
            class="close-btn"
          >
            <Icon name="material-symbols:close" size="18" />
          </el-button>
        </div>

        <!-- 认证面板插槽 -->
        <slot name="auth" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  promoAsset?: string
}

interface Emits {
  (e: 'close'): void
}

const props = withDefaults(defineProps<Props>(), {
  promoAsset: ''
})

const emit = defineEmits<Emits>()

// 响应式布局
const windowWidth = ref(768)
const isMobile = computed(() => windowWidth.value < 768)

const gridStyle = computed(() => {
  if (isMobile.value) {
    return {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '0',
      minHeight: '600px'
    }
  } else {
    return {
      display: 'grid',
      gridTemplateColumns: '55% 45%',
      gap: '0',
      minHeight: '500px'
    }
  }
})

// 监听窗口大小变化
onMounted(() => {
  const updateWidth = () => {
    windowWidth.value = window.innerWidth
  }
  updateWidth()
  window.addEventListener('resize', updateWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', () => {})
})

const handleClose = () => {
  emit('close')
}
</script>

<style scoped lang="scss">
.auth-shell {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  background: white;

  .promo-section {
    position: relative;
    overflow: hidden;

    @media (max-width: 767px) {
      display: none;
    }
  }

  .auth-section {
    display: flex;
    flex-direction: column;
    background: white;
    position: relative;

    .auth-content {
      flex: 1;
      position: relative;
      padding: 0;
      min-height: inherit;

      .close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        z-index: 10;

        .close-btn {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.05);
          color: #6b7280;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;

          &:hover {
            background: rgba(0, 0, 0, 0.1);
            color: #374151;
          }

          &:focus {
            outline: none;
            background: rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .auth-shell {
    height: 100vh;
    border-radius: 0;
    min-height: 100vh;

    .auth-section {
      flex: 1;

      .auth-content {
        min-height: 100vh;
      }
    }
  }
}
</style>